module.exports = __webpack_public_path__ + "img/placeholder_1.e7938aef.svg";